import { render } from "./PlusMinus.vue?vue&type=template&id=1fdbca21&scoped=true"
import script from "./PlusMinus.vue?vue&type=script&lang=js"
export * from "./PlusMinus.vue?vue&type=script&lang=js"

import "./PlusMinus.vue?vue&type=style&index=0&id=1fdbca21&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdbca21"]])

export default __exports__